import { useParams } from "react-router-dom";

/**
 * The inspection id from the route, lower-cased.
 *
 * Inspection GUIDs reach this app from ASIMS, whose SQL Server
 * `uniqueidentifier` stringifies UPPER-CASE (`212AB568-…`), so any link built
 * from an ASIMS-sourced id carries that casing into the URL. The inspect
 * backend keys DynamoDB on the exact `inspectionId` string, so an upper-case id
 * misses the record and the route 404s on a healthy inspection.
 *
 * Ids are matched lower-case platform-wide (the same rule
 * `gradingService.normaliseInspectionId` applies). Normalising once here, at
 * the route boundary, keeps every page on the convention rather than leaving
 * each service to remember it.
 */
export const useInspectionId = (): string | undefined =>
    useParams<{ inspectionId: string }>().inspectionId?.toLowerCase();
